import { Injectable } from '@angular/core';
import { FiNotificationService } from '@fi-app/utilities/notification/notification.service';
import { UpgradeMessageNotificationComponent } from '@fi-app/utilities/notification/upgrade-message-notification/upgrade-message-notification.component';
import { FiCustomerDataService, IFiCustomerData } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { AppTextService } from '@fi-shared/app-text';
import { isNullOrUndefined } from 'util';

@Injectable()
export class UpgradeMessageNotificationService {
    constructor(
        private notificationService: FiNotificationService,
        private customerDataService: FiCustomerDataService,
    ) {}

    checkUpgradeMessageNotification() {
        if (this.isOngoingUpgrade() || this.isUpcomingUpgrade()) {
            return this.notificationService.AddNotification(UpgradeMessageNotificationComponent);
        }
    }

    isOngoingUpgrade() {
        const numberOfDaysTillNextUpgrade = this.getNumberOfDaysTillNextUpgrade();
        return !isNullOrUndefined(numberOfDaysTillNextUpgrade) && numberOfDaysTillNextUpgrade <= 0;
    }

    isUpcomingUpgrade() {
        const numberOfDaysTillNextUpgrade = this.getNumberOfDaysTillNextUpgrade();
        return (
            !isNullOrUndefined(numberOfDaysTillNextUpgrade) &&
            numberOfDaysTillNextUpgrade > 0 &&
            numberOfDaysTillNextUpgrade <= 1
        );
    }

    private getNumberOfDaysTillNextUpgrade() {
        const customerData = this.customerDataService.getCustomerData();
        return customerData.UpcomingVersion
            ? customerData.UpcomingVersion.SecondsUntilUpgradeStart / 60 / 60 / 24
            : null;
    }
}
